import { useQuery } from '@tanstack/react-query';
import { STATIC } from '../../lib/queryPresets';
import * as svc from '../../services/stats/statsService';

export const statsKeys = {
  byStage: ['stats-dossiers-by-stage'] as const,
  byType: ['stats-dossiers-by-type'] as const,
  revenue: ['stats-revenue-monthly'] as const,
  hours: ['stats-hours-by-lawyer'] as const,
  profitability: ['stats-dossier-profitability'] as const,
};

export function useStatsDossiersByStage() {
  return useQuery({
    ...STATIC,
    queryKey: statsKeys.byStage,
    queryFn: svc.listStatsDossiersByStage,
  });
}

export function useStatsDossiersByType() {
  return useQuery({
    ...STATIC,
    queryKey: statsKeys.byType,
    queryFn: svc.listStatsDossiersByType,
  });
}

export function useStatsRevenueMonthly() {
  return useQuery({
    ...STATIC,
    queryKey: statsKeys.revenue,
    queryFn: svc.listStatsRevenueMonthly,
  });
}

export function useStatsHoursByLawyer() {
  return useQuery({
    ...STATIC,
    queryKey: statsKeys.hours,
    queryFn: svc.listStatsHoursByLawyer,
  });
}

export function useStatsDossierProfitability() {
  return useQuery({
    ...STATIC,
    queryKey: statsKeys.profitability,
    queryFn: svc.listStatsDossierProfitability,
  });
}
